import { useEffect, useState } from "react";

function TypewriterHTML({ html, speed = 5 }) {
  const [displayed, setDisplayed] = useState("");

  useEffect(() => {
    let i = 0;
    setDisplayed("");

    const interval = setInterval(() => {
      setDisplayed(html.slice(0, i));
      i++;

      if (i > html.length) {
        clearInterval(interval);
      }
    }, speed);

    return () => clearInterval(interval);
  }, [html, speed]);

  return (
    <div
      className="ql-editor"
      dangerouslySetInnerHTML={{
        __html: displayed,
      }}
    />
  );
}

export default TypewriterHTML;
